import REC_SELECT_APAC from './APAC';
import REC_SELECT_EMEA from './EMEA';

const I18N = {
  REC_SELECT_EMEA,
  REC_SELECT_APAC,
};

export { I18N as default, REC_SELECT_APAC, REC_SELECT_EMEA };
